// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { TextFieldPresentationProps } from "@flip/MobiusOverrides/TextField";
import { color } from "@flip/XDL/Utilities";
import { ClickableProps } from "@insite/mobius/Clickable";
import { IconWrapper } from "@insite/mobius/Icon";
import { getProp } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { css } from "styled-components";

export interface QuantityInputStyles {
    wrapper?: InjectableCss;
    actionClickable?: ClickableProps;
    quantityOrderedTextField?: TextFieldPresentationProps;
}

export const quantityInputStyle: QuantityInputStyles = {
    wrapper: {
        css: css`
            background: ${color("common.white")};
            border: 1px solid ${color("common.ui5")};
            border-radius: 4px;
            display: flex;
            align-items: center;
            height: 30px;
            max-width: 106px;
            min-width: 106px;
            overflow: hidden;

            &:hover {
                border-color: ${color("common.ui13")};
            }

            &:focus-within {
                border-color: ${color("common.ui12")};
            }
        `,
    },
    actionClickable: {
        css: css`
            height: 26px;
            padding: 0 8px;
            display: flex;
            align-items: center;
            transition: all ${getProp("theme.transition.duration.regular")}ms ease-in-out;
            ${IconWrapper} {
                color: ${color("common.ui3")};
            }
            &:hover {
                ${IconWrapper} {
                    color: ${color("primary")};
                }
            }
            &:focus {
                outline: none;
            }
        `,
    },
    quantityOrderedTextField: {
        cssOverrides: {
            inputSelect: css`
                height: 26px;
                font-size: 14px;
                letter-spacing: 0;
                line-height: 16px;
                text-align: center;
                padding: 0 !important;

                &,
                &:hover,
                &:focus {
                    border: none !important;
                    box-shadow: none !important;
                }
                &:disabled {
                    background-color: ${color("common.background")};
                }
            `,
        },
    },
};
